export default {
  CHAT_EVENT_PAGE_SIZE: 75,
  CHAT_EVENT_PAGE_SIZE_APP: 75,
  CHAT_BUBBLE_SIZE: 38,
};
